import { Component, ViewEncapsulation, OnInit, Input, ViewChildren, QueryList, AfterViewInit, ViewChild } from '@angular/core';
import { Drawer10Service } from "../../assets/services/drawer10.service";
import { MatCalendarCellCssClasses, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as firebase from 'firebase';
export interface Item { name: string; rate: number;}

import 'rxjs';
import * as moment from 'moment';
import * as _ from 'lodash';
import { DaterangepickerComponent } from 'ngx-daterangepicker-material';

declare function snipMe(): any;


@Component({
  selector: 'reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})

export class ReportsComponent implements AfterViewInit {
  //----------------default 'today' selected in range list--------------
  @ViewChild(DaterangepickerComponent, {static: true}) private datePicker: DaterangepickerComponent;
  //----------------default 'today' selected in range list--------------

  
  value=0; //progressbar



  //-------------------------
  shop1bills: any =0;
  shop2bills: any =0;
  shop3bills: any =0;

  partytypes: any =0;
  seasonaltypes: any =0;
  festivaltypes: any =0;
  regulartypes: any =0;

  gsttypes: any =0;
  igsttypes: any =0;
  taxfreetypes: any =0;

  shopbillsarry: { shop1bills: number; shop2bills: number; shop3bills: number }[]= [];
  customertypesarry: { partytypes: number; seasonaltypes: number; festivaltypes: number; regulartypes: number }[]= [];
  taxtypesarry: { gsttypes: number; igsttypes: number; taxfreetypes: number }[]= [];

  
  partytypess1: any =0;
  seasonaltypess1: any =0;
  festivaltypess1: any =0;
  regulartypess1: any =0;

  gsttypess1: any =0;
  igsttypess1: any =0;
  taxfreetypess1: any =0;

  partygsttypes1: any =0;
  seasonalgsttypes1: any =0;
  festivalgsttypes1: any =0;
  regulargsttypes1: any =0;
  partyigsttypes1: any =0;
  seasonaligsttypes1: any =0;
  festivaligsttypes1: any =0;
  regularigsttypes1: any =0;
  partytaxfreetypess1: any =0;
  seasonaltaxfreetypess1: any =0;
  festivaltaxfreetypess1: any =0;
  regulartaxfreetypess1: any =0;

  customertypess1arry: { partytypess1: number; seasonaltypess1: number; festivaltypess1: number; regulartypess1: number }[]= [];
  taxtypess1arry: { gsttypess1: number; igsttypess1: number; taxfreetypess1: number }[]= [];
  customertaxtypes1arry: {partygsttypes1: number; seasonalgsttypes1: number; festivalgsttypes1: number; regulargsttypes1:number; partyigsttypes1:number; seasonaligsttypes1:number; festivaligsttypes1:number; regularigsttypes1:number; partytaxfreetypess1:number; seasonaltaxfreetypess1:number; festivaltaxfreetypess1:number; regulartaxfreetypess1:number}[]= [];

  partytypess2: any =0;
  seasonaltypess2: any =0;
  festivaltypess2: any =0;
  regulartypess2: any =0;

  gsttypess2: any =0;
  igsttypess2: any =0;
  taxfreetypess2: any =0;

  partygsttypes2: any =0;
  seasonalgsttypes2: any =0;
  festivalgsttypes2: any =0;
  regulargsttypes2: any =0;
  partyigsttypes2: any =0;
  seasonaligsttypes2: any =0;
  festivaligsttypes2: any =0;
  regularigsttypes2: any =0;
  partytaxfreetypess2: any =0;
  seasonaltaxfreetypess2: any =0;
  festivaltaxfreetypess2: any =0;
  regulartaxfreetypess2: any =0;

  customertypess2arry: { partytypess2: number; seasonaltypess2: number; festivaltypess2: number; regulartypess2: number }[]= [];
  taxtypess2arry: { gsttypess2: number; igsttypess2: number; taxfreetypess2: number }[]= [];
  customertaxtypes2arry: {partygsttypes2: number; seasonalgsttypes2: number; festivalgsttypes2: number; regulargsttypes2:number; partyigsttypes2:number; seasonaligsttypes2:number; festivaligsttypes2:number; regularigsttypes2:number; partytaxfreetypess2:number; seasonaltaxfreetypess2:number; festivaltaxfreetypess2:number; regulartaxfreetypess2:number}[]= [];


  partytypesS3: any =0;
  seasonaltypesS3: any =0;
  festivaltypesS3: any =0;
  regulartypesS3: any =0;

  gsttypesS3: any =0;
  igsttypesS3: any =0;
  taxfreetypesS3: any =0;

  partygsttypeS3: any =0;
  seasonalgsttypeS3: any =0;
  festivalgsttypeS3: any =0;
  regulargsttypeS3: any =0;
  partyigsttypeS3: any =0;
  seasonaligsttypeS3: any =0;
  festivaligsttypeS3: any =0;
  regularigsttypeS3: any =0;
  partytaxfreetypesS3: any =0;
  seasonaltaxfreetypesS3: any =0;
  festivaltaxfreetypesS3: any =0;
  regulartaxfreetypesS3: any =0;

  customertypesS3arry: { partytypesS3: number; seasonaltypesS3: number; festivaltypesS3: number; regulartypesS3: number }[]= [];
  taxtypesS3arry: { gsttypesS3: number; igsttypesS3: number; taxfreetypesS3: number }[]= [];
  customertaxtypeS3arry: {partygsttypeS3: number; seasonalgsttypeS3: number; festivalgsttypeS3: number; regulargsttypeS3:number; partyigsttypeS3:number; seasonaligsttypeS3:number; festivaligsttypeS3:number; regularigsttypeS3:number; partytaxfreetypesS3:number; seasonaltaxfreetypesS3:number; festivaltaxfreetypesS3:number; regulartaxfreetypesS3:number}[]= [];

//-------------------------


  message10:boolean;

  st: string;
  step: string;


  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }


  filterValue = {
    dates: String(moment().format('DD-MM-YYYY')),
    datee: String(moment().format('DD-MM-YYYY')),
  };


  tottaxableamtpre: number;
  totamtwithtaxpre: number;
  sumaftrdiscpre: number;

  tottaxableamt: { billid:any; tottaxableamtpre: number }[]= [];
  totamtwithtax: { billid:any; totamtwithtaxpre: number }[]= [];
  sumaftrdisc: { billid:any; sumaftrdiscpre: number }[]= [];

  totalamountpre: number;
  totalamount: { billid:any; totalamountpre: number }[]= [];

  totalrate: number;
  summy: { billid:any, shop:string, gst: number, rate: number, taxtype:string, taxableamt: number, amtaftdisc:number }[]= [];
  summypre: { billid:any, shop:string, gst: number, rate: number, taxtype:string, taxableamt: number, amtaftdisc:number }[]= [];

  pcollection: any;
  acollection: any;

  todaydate=moment().format('DD-MM-YYYY'); 
  overallsumamtaftdisc: number;
  overallsumtaxableamt: number;
  overallsumamtwithtax: number;

  totalbillspre: number;
  totalbills: { date:any;  totalbillspre:number}[]= [];
  overallsumbills: number;



  otxamnts1gst: number;
  otxamnts2gst: number;
  otxamnts3gst: number;
  otxamnts1igst: number;
  otxamnts2igst: number;
  otxamnts3igst: number;
  otxamnts1taxfree: number;
  otxamnts2taxfree: number;
  otxamnts3taxfree: number;

  osmamntwitxs1: number;
  osmamntwitxs2: number;
  osmamntwitxs3: number;

  dateRangeFired=false;
  summy2:{ billid:any, shop:string, gst: number, rate: number, taxtype:string, taxableamt: number, amtaftdisc:number }[]= [];

  // selectedOptions: string[] = [];

  constructor(private _snackBar: MatSnackBar, private data10: Drawer10Service, private afs: AngularFirestore) { }
  @ViewChildren('allTheseThings') things: QueryList<any>;

  
  ngForRendred() {
    console.log('NgFor is Rendered');
    snipMe();
    }


    
   addorreplace(array, item){
    const i=array.findIndex(_item => _item.billid===item.billid);
    if(i>-1) array[i] =item;
    else array.push(item);
   }

   addorreplace2(array, item){
    const i=array.findIndex(_item => _item.date===item.date);
    if(i>-1) array[i] =item;
    else array.push(item);
   }


   openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
      verticalPosition:'top',
      horizontalPosition: 'end',      
      panelClass: 'snackbar'
    });
  }

  ngAfterViewInit() {
//----------------default 'today' selected in range list--------------
// this.datePicker.setStartDate(moment());
// this.datePicker.setEndDate(moment());
// this.datePicker.updateView();
//----------------default 'today' selected in range list--------------
    this.openSnackBar("Select Date Range First!","OK");
  this.st="step1";
  this.step="step1";

    this.data10.currentMessage10.subscribe(message10 => this.message10 = message10)
console.log("PL"+this.message10);

//this.applyFilter();

//-----------------------newly added----------------------------------------------------------------
// this.acollection = this.afs.collection('Bills').snapshotChanges()
// .pipe( 
//   map(actions => actions.map(a => a.payload.doc.data()))
// );

// this.acollection.subscribe(() => {this.applyFilter()})
//-----------------------newly added----------------------------------------------------------------


  }
         
  rangeClicked(range) {
    console.log('[rangeClicked] range is : ', range);
    
   console.log(range.dates[0].format('DD-MM-YYYY'));
   console.log(range.dates[1].format('DD-MM-YYYY'));
   this.applyFilter2(0,range.dates[0],range.dates[1])
  }
  datesUpdated(range) {
    if (this.dateRangeFired) {
      this.dateRangeFired = false;
      console.log("dateRangeFired not fired")

      console.log('[datesUpdated] range is : ', range);

      console.log(range.startDate.format('DD-MM-YYYY'));
      console.log(range.endDate.format('DD-MM-YYYY'));
      this.applyFilter2(1, range.startDate, range.endDate)
      return;
    }
    this.dateRangeFired = true;

  }
  choosedDate(range) {
    console.log('[choosedDate] range is : ', range);

  console.log(range.startDate.format('DD-MM-YYYY'));
  console.log(range.endDate.format('DD-MM-YYYY'));
  this.applyFilter2(2,range.startDate,range.endDate)
   }

 async applyFilter2(status,sd,ed) {

   // console.log(event.startDate);
   // console.log(event.endDate);
if(status==0){
    this.filterValue.dates = moment(sd).format('DD-MM-YYYY'); 
    this.filterValue.datee = moment(ed).format('DD-MM-YYYY'); 
    console.log("S: "+this.filterValue.dates);
    console.log("E: "+this.filterValue.datee);
}
if(status==1 || status==2){
  this.filterValue.dates = moment(sd).format('DD-MM-YYYY'); 
  this.filterValue.datee = moment(ed).format('DD-MM-YYYY'); 
  console.log("S: "+this.filterValue.dates);
  console.log("E: "+this.filterValue.datee);
}
    this.applyFilter();
  };


  applyFilter(){
         
this.tottaxableamtpre=0;
this.totamtwithtaxpre=0; 
this.sumaftrdiscpre=0; 

this.totalamountpre=0;

this.tottaxableamt=[];
this.totamtwithtax=[]; 
this.sumaftrdisc=[]; 
this.totalamount=[];

this.summy=[];

this.totalbillspre=0;
this.totalbills=[];

this.overallsumtaxableamt = 0;
this.overallsumamtwithtax = 0;
this.overallsumamtaftdisc = 0;
this.overallsumbills=0;
      //-------------------------
      this.shopbillsarry=[];
      this.shop1bills =0;
      this.shop2bills =0;
      this.shop3bills =0;
      
      this.customertypesarry=[];
      this.partytypes =0;
      this.seasonaltypes =0;
      this.festivaltypes =0;
      this.regulartypes =0;
      
      this.taxtypesarry=[];
      this.gsttypes =0;
      this.igsttypes =0;
      this.taxfreetypes =0;
      
      this.customertypess1arry=[];
      this.partytypess1 =0;
      this.seasonaltypess1 =0;
      this.festivaltypess1 =0;
      this.regulartypess1 =0;
      
      this.taxtypess1arry=[];
      this.gsttypess1 =0;
      this.igsttypess1 =0;
      this.taxfreetypess1 =0;
      
      this.customertaxtypes1arry=[];
      this.partygsttypes1 =0;
      this.seasonalgsttypes1 =0;
      this.festivalgsttypes1 =0;
      this.regulargsttypes1 =0;
      this.partyigsttypes1 =0;
      this.seasonaligsttypes1 =0;
      this.festivaligsttypes1 =0;
      this.regularigsttypes1 =0;
      this.partytaxfreetypess1 =0;
      this.seasonaltaxfreetypess1 =0;
      this.festivaltaxfreetypess1 =0;
      this.regulartaxfreetypess1 =0;

      this.customertypess2arry=[];
      this.partytypess2 =0;
      this.seasonaltypess2 =0;
      this.festivaltypess2 =0;
      this.regulartypess2 =0;
      
      this.taxtypess2arry=[];
      this.gsttypess2 =0;
      this.igsttypess2 =0;
      this.taxfreetypess2 =0;
      
      this.customertaxtypes2arry=[];
      this.partygsttypes2 =0;
      this.seasonalgsttypes2 =0;
      this.festivalgsttypes2 =0;
      this.regulargsttypes2 =0;
      this.partyigsttypes2 =0;
      this.seasonaligsttypes2 =0;
      this.festivaligsttypes2 =0;
      this.regularigsttypes2 =0;
      this.partytaxfreetypess2 =0;
      this.seasonaltaxfreetypess2 =0;
      this.festivaltaxfreetypess2 =0;
      this.regulartaxfreetypess2 =0;

      this.customertypesS3arry=[];
      this.partytypesS3 =0;
      this.seasonaltypesS3 =0;
      this.festivaltypesS3 =0;
      this.regulartypesS3 =0;
      
      this.taxtypesS3arry=[];
      this.gsttypesS3 =0;
      this.igsttypesS3 =0;
      this.taxfreetypesS3 =0;

      this.customertaxtypeS3arry=[];
      this.partygsttypeS3 =0;
      this.seasonalgsttypeS3 =0;
      this.festivalgsttypeS3 =0;
      this.regulargsttypeS3 =0;
      this.partyigsttypeS3 =0;
      this.seasonaligsttypeS3 =0;
      this.festivaligsttypeS3 =0;
      this.regularigsttypeS3 =0;
      this.partytaxfreetypesS3 =0;
      this.seasonaltaxfreetypesS3 =0;
      this.festivaltaxfreetypesS3 =0;
      this.regulartaxfreetypesS3 =0;
      //-------------------------
      
      this.otxamnts1gst = 0;
      this.otxamnts2gst = 0;
  this.otxamnts3gst = 0;
  this.otxamnts1igst = 0;
  this.otxamnts2igst = 0;
  this.otxamnts3igst = 0;
  this.otxamnts1taxfree = 0;
  this.otxamnts2taxfree = 0;
  this.otxamnts3taxfree = 0;

  this.osmamntwitxs1 = 0;
  this.osmamntwitxs2 = 0;
  this.osmamntwitxs3 = 0;


  
    this.afs.collection('Bills').get().toPromise().then(querySnapshot => {

      querySnapshot.forEach(doc => {
        if((moment(doc.data().date2, "DD-MM-YYYY").toDate()) >= (moment(this.filterValue.dates, "DD-MM-YYYY").toDate())
        && (moment(doc.data().date2, "DD-MM-YYYY").toDate()) <= (moment(this.filterValue.datee, "DD-MM-YYYY").toDate())
        && doc.data().billsid)
        {
          console.log(true,moment(doc.data().date2, "DD-MM-YYYY").toDate());

          for(let i=1;i<=doc.data().billsid.length;i++){
   
            this.tottaxableamtpre=0;
            this.totamtwithtaxpre=0; 
            this.sumaftrdiscpre=0; 
        
            this.totalamountpre=0;
        
          this.afs.collection('Bills').doc(moment(moment(doc.data().date2, "DD-MM-YYYY").toDate()).format("DD-MM-YYYY")).collection('--Id--',ref => ref.where('currentbillid', '==', Number(doc.data().billsid[i-1].substring(4)))).get().toPromise().then(querySnapshot => {
            querySnapshot.forEach(docy => {
                          this.pcollection = this.afs.collection('Bills').doc(moment(moment(doc.data().date2, "DD-MM-YYYY").toDate()).format("DD-MM-YYYY")).collection(String(docy.data().currentbillid)).snapshotChanges()
                          .pipe( 
                            map(actions => actions.map(a => a.payload.doc.data()))
           );
    
//-------------------------
if (String(doc.data().billsid[i-1]).slice(0, 2) == "S1") {
  this.shop1bills = this.shop1bills+1;
  this.addorreplace(this.shopbillsarry,{'shop1bills':this.shop1bills , 'shop2bills':this.shop2bills, 'shop3bills':this.shop3bills})


  if (String(doc.data().billsid[i-1]).slice(2, 3) == "P") {
    this.partytypess1 = this.partytypess1+1;
    this.addorreplace(this.customertypess1arry,{'partytypess1':this.partytypess1 , 'seasonaltypess1':this.seasonaltypess1, 'festivaltypess1':this.festivaltypess1, 'regulartypess1':this.regulartypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S") {
    this.seasonaltypess1 = this.seasonaltypess1+1;
    this.addorreplace(this.customertypess1arry,{'partytypess1':this.partytypess1 , 'seasonaltypess1':this.seasonaltypess1, 'festivaltypess1':this.festivaltypess1, 'regulartypess1':this.regulartypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F") {
    this.festivaltypess1 = this.festivaltypess1+1;
    this.addorreplace(this.customertypess1arry,{'partytypess1':this.partytypess1 , 'seasonaltypess1':this.seasonaltypess1, 'festivaltypess1':this.festivaltypess1, 'regulartypess1':this.regulartypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R") {
    this.regulartypess1 = this.regulartypess1+1;
    this.addorreplace(this.customertypess1arry,{'partytypess1':this.partytypess1 , 'seasonaltypess1':this.seasonaltypess1, 'festivaltypess1':this.festivaltypess1, 'regulartypess1':this.regulartypess1})
  }

  if (String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.gsttypess1 = this.gsttypess1+1;
    this.addorreplace(this.taxtypess1arry,{'gsttypess1':this.gsttypess1 , 'igsttypess1':this.igsttypess1, 'taxfreetypess1':this.taxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.igsttypess1 = this.igsttypess1+1;
    this.addorreplace(this.taxtypess1arry,{'gsttypess1':this.gsttypess1 , 'igsttypess1':this.igsttypess1, 'taxfreetypess1':this.taxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.taxfreetypess1 = this.taxfreetypess1+1;
    this.addorreplace(this.taxtypess1arry,{'gsttypess1':this.gsttypess1 , 'igsttypess1':this.igsttypess1, 'taxfreetypess1':this.taxfreetypess1})
  }

  if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.partygsttypes1 = this.partygsttypes1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.seasonalgsttypes1 = this.seasonalgsttypes1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.festivalgsttypes1 = this.festivalgsttypes1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.regulargsttypes1 = this.regulargsttypes1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.partyigsttypes1 = this.partyigsttypes1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.seasonaligsttypes1 = this.seasonaligsttypes1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.festivaligsttypes1 = this.festivaligsttypes1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.regularigsttypes1 = this.regularigsttypes1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.partytaxfreetypess1 = this.partytaxfreetypess1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.seasonaltaxfreetypess1 = this.seasonaltaxfreetypess1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.festivaltaxfreetypess1 = this.festivaltaxfreetypess1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.regulartaxfreetypess1 = this.regulartaxfreetypess1+1;
    this.addorreplace(this.customertaxtypes1arry,{'partygsttypes1': this.partygsttypes1, 'seasonalgsttypes1': this.seasonalgsttypes1, 'festivalgsttypes1': this.festivalgsttypes1, 'regulargsttypes1':this.regulargsttypes1, 'partyigsttypes1':this.partyigsttypes1, 'seasonaligsttypes1':this.seasonaligsttypes1, 'festivaligsttypes1':this.festivaligsttypes1, 'regularigsttypes1':this.regularigsttypes1, 'partytaxfreetypess1':this.partytaxfreetypess1, 'seasonaltaxfreetypess1':this.seasonaltaxfreetypess1, 'festivaltaxfreetypess1':this.festivaltaxfreetypess1, 'regulartaxfreetypess1':this.regulartaxfreetypess1})
  }

}
else if (String(doc.data().billsid[i-1]).slice(0, 2) == "S2") {
  this.shop2bills = this.shop2bills+1;
  this.addorreplace(this.shopbillsarry,{'shop1bills':this.shop1bills , 'shop2bills':this.shop2bills, 'shop3bills':this.shop3bills})


  if (String(doc.data().billsid[i-1]).slice(2, 3) == "P") {
    this.partytypess2 = this.partytypess2+1;
    this.addorreplace(this.customertypess2arry,{'partytypess2':this.partytypess2 , 'seasonaltypess2':this.seasonaltypess2, 'festivaltypess2':this.festivaltypess2, 'regulartypess2':this.regulartypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S") {
    this.seasonaltypess2 = this.seasonaltypess2+1;
    this.addorreplace(this.customertypess2arry,{'partytypess2':this.partytypess2 , 'seasonaltypess2':this.seasonaltypess2, 'festivaltypess2':this.festivaltypess2, 'regulartypess2':this.regulartypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F") {
    this.festivaltypess2 = this.festivaltypess2+1;
    this.addorreplace(this.customertypess2arry,{'partytypess2':this.partytypess2 , 'seasonaltypess2':this.seasonaltypess2, 'festivaltypess2':this.festivaltypess2, 'regulartypess2':this.regulartypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R") {
    this.regulartypess2 = this.regulartypess2+1;
    this.addorreplace(this.customertypess2arry,{'partytypess2':this.partytypess2 , 'seasonaltypess2':this.seasonaltypess2, 'festivaltypess2':this.festivaltypess2, 'regulartypess2':this.regulartypess2})
  }

  if (String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.gsttypess2 = this.gsttypess2+1;
    this.addorreplace(this.taxtypess2arry,{'gsttypess2':this.gsttypess2 , 'igsttypess2':this.igsttypess2, 'taxfreetypess2':this.taxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.igsttypess2 = this.igsttypess2+1;
    this.addorreplace(this.taxtypess2arry,{'gsttypess2':this.gsttypess2 , 'igsttypess2':this.igsttypess2, 'taxfreetypess2':this.taxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.taxfreetypess2 = this.taxfreetypess2+1;
    this.addorreplace(this.taxtypess2arry,{'gsttypess2':this.gsttypess2 , 'igsttypess2':this.igsttypess2, 'taxfreetypess2':this.taxfreetypess2})
  }

  if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.partygsttypes2 = this.partygsttypes2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.seasonalgsttypes2 = this.seasonalgsttypes2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.festivalgsttypes2 = this.festivalgsttypes2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.regulargsttypes2 = this.regulargsttypes2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.partyigsttypes2 = this.partyigsttypes2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.seasonaligsttypes2 = this.seasonaligsttypes2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.festivaligsttypes2 = this.festivaligsttypes2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.regularigsttypes2 = this.regularigsttypes2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.partytaxfreetypess2 = this.partytaxfreetypess2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.seasonaltaxfreetypess2 = this.seasonaltaxfreetypess2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.festivaltaxfreetypess2 = this.festivaltaxfreetypess2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.regulartaxfreetypess2 = this.regulartaxfreetypess2+1;
    this.addorreplace(this.customertaxtypes2arry,{'partygsttypes2': this.partygsttypes2, 'seasonalgsttypes2': this.seasonalgsttypes2, 'festivalgsttypes2': this.festivalgsttypes2, 'regulargsttypes2':this.regulargsttypes2, 'partyigsttypes2':this.partyigsttypes2, 'seasonaligsttypes2':this.seasonaligsttypes2, 'festivaligsttypes2':this.festivaligsttypes2, 'regularigsttypes2':this.regularigsttypes2, 'partytaxfreetypess2':this.partytaxfreetypess2, 'seasonaltaxfreetypess2':this.seasonaltaxfreetypess2, 'festivaltaxfreetypess2':this.festivaltaxfreetypess2, 'regulartaxfreetypess2':this.regulartaxfreetypess2})
  }

}
else if (String(doc.data().billsid[i-1]).slice(0, 2) == "S3") {
  this.shop3bills = this.shop3bills+1;
  this.addorreplace(this.shopbillsarry,{'shop1bills':this.shop1bills , 'shop2bills':this.shop2bills, 'shop3bills':this.shop3bills})

  if (String(doc.data().billsid[i-1]).slice(2, 3) == "P") {
    this.partytypesS3 = this.partytypesS3+1;
    this.addorreplace(this.customertypesS3arry,{'partytypesS3':this.partytypesS3 , 'seasonaltypesS3':this.seasonaltypesS3, 'festivaltypesS3':this.festivaltypesS3, 'regulartypesS3':this.regulartypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S") {
    this.seasonaltypesS3 = this.seasonaltypesS3+1;
    this.addorreplace(this.customertypesS3arry,{'partytypesS3':this.partytypesS3 , 'seasonaltypesS3':this.seasonaltypesS3, 'festivaltypesS3':this.festivaltypesS3, 'regulartypesS3':this.regulartypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F") {
    this.festivaltypesS3 = this.festivaltypesS3+1;
    this.addorreplace(this.customertypesS3arry,{'partytypesS3':this.partytypesS3 , 'seasonaltypesS3':this.seasonaltypesS3, 'festivaltypesS3':this.festivaltypesS3, 'regulartypesS3':this.regulartypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R") {
    this.regulartypesS3 = this.regulartypesS3+1;
    this.addorreplace(this.customertypesS3arry,{'partytypesS3':this.partytypesS3 , 'seasonaltypesS3':this.seasonaltypesS3, 'festivaltypesS3':this.festivaltypesS3, 'regulartypesS3':this.regulartypesS3})
  }

  if (String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.gsttypesS3 = this.gsttypesS3+1;
    this.addorreplace(this.taxtypesS3arry,{'gsttypesS3':this.gsttypesS3 , 'igsttypesS3':this.igsttypesS3, 'taxfreetypesS3':this.taxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.igsttypesS3 = this.igsttypesS3+1;
    this.addorreplace(this.taxtypesS3arry,{'gsttypesS3':this.gsttypesS3 , 'igsttypesS3':this.igsttypesS3, 'taxfreetypesS3':this.taxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.taxfreetypesS3 = this.taxfreetypesS3+1;
    this.addorreplace(this.taxtypesS3arry,{'gsttypesS3':this.gsttypesS3 , 'igsttypesS3':this.igsttypesS3, 'taxfreetypesS3':this.taxfreetypesS3})
  }

  if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.partygsttypeS3 = this.partygsttypeS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.seasonalgsttypeS3 = this.seasonalgsttypeS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.festivalgsttypeS3 = this.festivalgsttypeS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
    this.regulargsttypeS3 = this.regulargsttypeS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.partyigsttypeS3 = this.partyigsttypeS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.seasonaligsttypeS3 = this.seasonaligsttypeS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.festivaligsttypeS3 = this.festivaligsttypeS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
    this.regularigsttypeS3 = this.regularigsttypeS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "P" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.partytaxfreetypesS3 = this.partytaxfreetypesS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.seasonaltaxfreetypesS3 = this.seasonaltaxfreetypesS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.festivaltaxfreetypesS3 = this.festivaltaxfreetypesS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }
  else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R" && String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
    this.regulartaxfreetypesS3 = this.regulartaxfreetypesS3+1;
    this.addorreplace(this.customertaxtypeS3arry,{'partygsttypeS3': this.partygsttypeS3, 'seasonalgsttypeS3': this.seasonalgsttypeS3, 'festivalgsttypeS3': this.festivalgsttypeS3, 'regulargsttypeS3':this.regulargsttypeS3, 'partyigsttypeS3':this.partyigsttypeS3, 'seasonaligsttypeS3':this.seasonaligsttypeS3, 'festivaligsttypeS3':this.festivaligsttypeS3, 'regularigsttypeS3':this.regularigsttypeS3, 'partytaxfreetypesS3':this.partytaxfreetypesS3, 'seasonaltaxfreetypesS3':this.seasonaltaxfreetypesS3, 'festivaltaxfreetypesS3':this.festivaltaxfreetypesS3, 'regulartaxfreetypesS3':this.regulartaxfreetypesS3})
  }

}

if (String(doc.data().billsid[i-1]).slice(2, 3) == "P") {
  this.partytypes = this.partytypes+1;
  this.addorreplace(this.customertypesarry,{'partytypes':this.partytypes , 'seasonaltypes':this.seasonaltypes, 'festivaltypes':this.festivaltypes, 'regulartypes':this.regulartypes})
}
else if (String(doc.data().billsid[i-1]).slice(2, 3) == "S") {
  this.seasonaltypes = this.seasonaltypes+1;
  this.addorreplace(this.customertypesarry,{'partytypes':this.partytypes , 'seasonaltypes':this.seasonaltypes, 'festivaltypes':this.festivaltypes, 'regulartypes':this.regulartypes})
}
else if (String(doc.data().billsid[i-1]).slice(2, 3) == "F") {
  this.festivaltypes = this.festivaltypes+1;
  this.addorreplace(this.customertypesarry,{'partytypes':this.partytypes , 'seasonaltypes':this.seasonaltypes, 'festivaltypes':this.festivaltypes, 'regulartypes':this.regulartypes})
}
else if (String(doc.data().billsid[i-1]).slice(2, 3) == "R") {
  this.regulartypes = this.regulartypes+1;
  this.addorreplace(this.customertypesarry,{'partytypes':this.partytypes , 'seasonaltypes':this.seasonaltypes, 'festivaltypes':this.festivaltypes, 'regulartypes':this.regulartypes})
}

if (String(doc.data().billsid[i-1]).slice(3, 4) == "G") {
  this.gsttypes = this.gsttypes+1;
  this.addorreplace(this.taxtypesarry,{'gsttypes':this.gsttypes , 'igsttypes':this.igsttypes, 'taxfreetypes':this.taxfreetypes})
}
else if (String(doc.data().billsid[i-1]).slice(3, 4) == "I") {
  this.igsttypes = this.igsttypes+1;
  this.addorreplace(this.taxtypesarry,{'gsttypes':this.gsttypes , 'igsttypes':this.igsttypes, 'taxfreetypes':this.taxfreetypes})
}
else if (String(doc.data().billsid[i-1]).slice(3, 4) == "T") {
  this.taxfreetypes = this.taxfreetypes+1;
  this.addorreplace(this.taxtypesarry,{'gsttypes':this.gsttypes , 'igsttypes':this.igsttypes, 'taxfreetypes':this.taxfreetypes})
}
//-------------------------

this.pcollection.subscribe((posts) => {


            console.log("posty:"+posts); //This is the array of posts, not an observable
        
            if(doc.data().billsid[i-1].substring(3,4)=='G'){
            this.summypre=(_(posts).groupBy('cgst')
              .map((objs, key) => {
                  return {
                'billid':doc.data().billsid[i-1].substring(4),
                'shop':String(doc.data().billsid[i-1]).slice(0, 2),
                'amtaftdisc': (_.sumBy(objs, 'amountafterdiscount')),
                'taxtype':'gst',
                'taxableamt':2 * ((parseFloat(key)) * (_.sumBy(objs, 'amountafterdiscount'))/100),
                  }
              })
              .value()
            );
            }
            if(doc.data().billsid[i-1].substring(3,4)=='I'){
              this.summypre=(_(posts).groupBy('igst')
                .map((objs, key) => {
                    return {
                  'billid':doc.data().billsid[i-1].substring(4),
                  'shop':String(doc.data().billsid[i-1]).slice(0, 2),
                  'amtaftdisc': (_.sumBy(objs, 'amountafterdiscount')),
                  'taxtype':'igst',
                  'taxableamt':((parseFloat(key)) * (_.sumBy(objs, 'amountafterdiscount'))/100),
                }
                })
                .value()
              );
              }
              if(doc.data().billsid[i-1].substring(3,4)=='T'){
                this.summypre=(_(posts).groupBy('taxfree')
                  .map((objs, key) => {
                      return {
                    'billid':doc.data().billsid[i-1].substring(4),
                    'shop':String(doc.data().billsid[i-1]).slice(0, 2),
                    'amtaftdisc': (_.sumBy(objs, 'amountafterdiscount')),
                    'taxtype':'taxfree',
                    'taxableamt':(parseFloat('0.00')),
                  }
                  })
                  .value()
                );
                }
               
                
            this.summy=this.summy.concat(this.summypre);

            //if yot want to delete it uncomment above line
//-----newly added--------
//this.summy= _.unionBy(this.summy, this.summypre, "billid");
//-----newly added--------

//-----newly added--------

// if(this.overallsumbills == 2 * (this.shop1bills+this.shop2bills+this.shop3bills)){
//   console.log("ESCAPE");
// this.partygsttypes1=this.partygsttypes1 / 2;
// this.partyigsttypes1=this.partyigsttypes1 /2;
// this.partytaxfreetypess1=this.partytaxfreetypess1 /2;
// this.festivalgsttypes1=this.festivalgsttypes1 / 2;
// this.festivaligsttypes1=this.festivaligsttypes1 / 2;
// this.festivaltaxfreetypess1=this.festivaltaxfreetypess1 / 2;
// this.seasonalgsttypes1=this.seasonalgsttypes1 / 2;
// this.seasonaligsttypes1=this.seasonaligsttypes1 / 2;
// this.seasonaltaxfreetypess1=this.seasonaltaxfreetypess1 / 2;
// this.regulargsttypes1=this.regulargsttypes1 / 2;
// this.regularigsttypes1=this.regularigsttypes1 / 2;
// this.regulartaxfreetypess1=this.regulartaxfreetypess1 / 2;
// this.shop1bills=this.shop1bills / 2;
// this.partygsttypes2=this.partygsttypes2 / 2;
// this.partyigsttypes2=this.partyigsttypes2 /2;
// this.partytaxfreetypess2=this.partytaxfreetypess2 /2;
// this.festivalgsttypes2=this.festivalgsttypes2 / 2;
// this.festivaligsttypes2=this.festivaligsttypes2 / 2;
// this.festivaltaxfreetypess2=this.festivaltaxfreetypess2 / 2;
// this.seasonalgsttypes2=this.seasonalgsttypes2 / 2;
// this.seasonaligsttypes2=this.seasonaligsttypes2 / 2;
// this.seasonaltaxfreetypess2=this.seasonaltaxfreetypess2 / 2;
// this.regulargsttypes2=this.regulargsttypes2 / 2;
// this.regularigsttypes2=this.regularigsttypes2 / 2;
// this.regulartaxfreetypess2=this.regulartaxfreetypess2 / 2;
// this.shop2bills=this.shop2bills / 2;
// this.partygsttypeS3=this.partygsttypeS3 / 2;
// this.partyigsttypeS3=this.partyigsttypeS3 /2;
// this.partytaxfreetypesS3=this.partytaxfreetypesS3 /2;
// this.festivalgsttypeS3=this.festivalgsttypeS3 / 2;
// this.festivaligsttypeS3=this.festivaligsttypeS3 / 2;
// this.festivaltaxfreetypesS3=this.festivaltaxfreetypesS3 / 2;
// this.seasonalgsttypeS3=this.seasonalgsttypeS3 / 2;
// this.seasonaligsttypeS3=this.seasonaligsttypeS3 / 2;
// this.seasonaltaxfreetypesS3=this.seasonaltaxfreetypesS3 / 2;
// this.regulargsttypeS3=this.regulargsttypeS3 / 2;
// this.regularigsttypeS3=this.regularigsttypeS3 / 2;
// this.regulartaxfreetypesS3=this.regulartaxfreetypesS3 / 2;
// this.shop3bills=this.shop3bills / 2;
// }
//-----newly added--------

            this.tottaxableamtpre=this.summypre.reduce((sum1, item1) => sum1 + item1.taxableamt, 0)
            this.totamtwithtaxpre=this.summypre.reduce((sum2, item2) => sum2 + item2.amtaftdisc, 0) + this.tottaxableamtpre;
            this.sumaftrdiscpre=this.summypre.reduce((sum2, item2) => sum2 + item2.amtaftdisc, 0);
        
            this.addorreplace(this.tottaxableamt,{'billid':doc.data().billsid[i-1].substring(4), tottaxableamtpre:this.tottaxableamtpre})
            this.addorreplace(this.totamtwithtax,{'billid':doc.data().billsid[i-1].substring(4), totamtwithtaxpre:this.totamtwithtaxpre})
            this.addorreplace(this.sumaftrdisc,{'billid':doc.data().billsid[i-1].substring(4), sumaftrdiscpre:this.sumaftrdiscpre})
        
            console.log("TAXXXX:"+JSON.stringify(this.totamtwithtax));
            console.log("SD: "+this.filterValue.dates);
            console.log("ED: "+this.filterValue.datee);
              console.log("SUMMYYY:"+JSON.stringify(this.summy));
        
        
              this.overallsumtaxableamt = this.summy.reduce((sum1, item1) => sum1 + item1.taxableamt, 0)
              this.overallsumamtwithtax = this.summy.reduce((sum2, item2) => sum2 + item2.amtaftdisc, 0) + this.overallsumtaxableamt;
        this.overallsumamtaftdisc = this.summy.reduce((sum2, item2) => sum2 + item2.amtaftdisc, 0);
    
        
      console.log("zzzzzzzzzzzzzzzzzzzzzzzzzz:"+this.overallsumamtaftdisc);

      this.totalbillspre=doc.data().billsid.length;
      this.addorreplace2(this.totalbills,{'date':doc.data().date2, totalbillspre:this.totalbillspre})
      this.overallsumbills = this.totalbills.reduce((sum2, item2) => sum2 + item2.totalbillspre, 0);


       this.otxamnts1gst=this.summy.filter(item => item.shop === "S1" && item.taxtype === "gst").reduce((a, b) => a + b.taxableamt, 0);
       this.otxamnts2gst=this.summy.filter(item => item.shop === "S2" && item.taxtype === "gst").reduce((a, b) => a + b.taxableamt, 0);
       this.otxamnts3gst=this.summy.filter(item => item.shop === "S3" && item.taxtype === "gst").reduce((a, b) => a + b.taxableamt, 0);
       this.otxamnts1igst=this.summy.filter(item => item.shop === "S1" && item.taxtype === "igst").reduce((a, b) => a + b.taxableamt, 0);
       this.otxamnts2igst=this.summy.filter(item => item.shop === "S2" && item.taxtype === "igst").reduce((a, b) => a + b.taxableamt, 0);
       this.otxamnts3igst=this.summy.filter(item => item.shop === "S3" && item.taxtype === "igst").reduce((a, b) => a + b.taxableamt, 0);
       this.otxamnts1taxfree=this.summy.filter(item => item.shop === "S1" && item.taxtype === "taxfree").reduce((a, b) => a + b.taxableamt, 0);
       this.otxamnts2taxfree=this.summy.filter(item => item.shop === "S2" && item.taxtype === "taxfree").reduce((a, b) => a + b.taxableamt, 0);
       this.otxamnts3taxfree=this.summy.filter(item => item.shop === "S3" && item.taxtype === "taxfree").reduce((a, b) => a + b.taxableamt, 0);


       this.osmamntwitxs1=this.summy.filter(item => item.shop === "S1").reduce((a, b) => a + b.amtaftdisc, 0);
       this.osmamntwitxs2=this.summy.filter(item => item.shop === "S2").reduce((a, b) => a + b.amtaftdisc, 0);
       this.osmamntwitxs3=this.summy.filter(item => item.shop === "S3").reduce((a, b) => a + b.amtaftdisc, 0);

    })

  })
})

      }
      
        }
        else{
          console.log(false,moment(doc.data().date2, "DD-MM-YYYY").toDate());
        }
      
  })
})


  }

}

